import { AddressByZipCodeModel, FormAddress } from '@/types';

export const parseAddressByZipCode = (data: AddressByZipCodeModel): Partial<FormAddress> => {
  const { city, stateAbbr } = data;
  const location = { stateAbbr, name: city, place: `${city} - ${stateAbbr}` };
  const address: Partial<FormAddress> = {
    location,
    complement: data.complement || '',
    neighborhood: data.district || '',
    street: data.street || '',
    number: '',
  };
  return address;
};
